import type { FallbackCopyKey, LocalizedErrorCopy } from './locales/types';

/**
 * `translateError`'s own English copy for errors the catalog has no entry for,
 * chosen by HTTP status. Named (rather than written inline at each branch) so
 * every POS language can translate them like any catalog entry.
 */
export const FALLBACK_COPY: Readonly<Record<FallbackCopyKey, LocalizedErrorCopy>> = {
  'fallback:generic': {
    title: 'Something went wrong',
    message: 'Something went wrong. Please try again.',
  },
  'fallback:signIn': {
    title: 'Please sign in',
    message: 'Please sign in to continue.',
  },
  'fallback:paymentDeclined': {
    title: 'Payment declined',
    message: 'The payment was declined and nothing was charged.',
    nextSteps: [
      'Try a different payment method.',
      'Contact the business if you believe this is a mistake.',
    ],
  },
  'fallback:checkInput': {
    title: 'Check your input',
    message: 'Please check your input and try again.',
  },
  'fallback:slowDown': {
    title: 'Slow down',
    message: 'Too many requests. Please try again later.',
  },
  'fallback:notFound': {
    title: 'Not found',
    message: 'We couldn’t find what you were looking for. It may have been moved or deleted.',
    nextSteps: ['Go back and try again from the previous screen.'],
  },
  'fallback:serverError': {
    title: 'Something went wrong',
    message: 'Something went wrong on our end. Please try again.',
  },
};

export const RETRY_LABEL_EN = 'Try again';
export const SUPPORT_REFERENCE_EN = 'If this keeps happening, contact support with this reference:';
